meedy.factory('meedy.wizardService', ['$q', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, baseService, objectHelper, config) {

        function WizardService() {

            this.checkIncompleteData = function () {
                return baseService.get(config.API_URL + '/wizards/checkIncompleteData').then(
                    function (successResponse) {
                        return $q.resolve(successResponse);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.saveFirstConfiguration = function (wrapper) {
                return baseService.post(config.API_URL + '/wizards/saveFirstConfiguration', wrapper).then(
                    function (successResponse) {
                        return $q.resolve(successResponse);
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };


        }

        return new WizardService();
    }
]);
